module.exports = __webpack_public_path__ + "img/bockel-shooting-werkstatt.c95a5ebd.webp";